import { createAction } from 'redux-actions';

export const clearInventoryItemAuditLogs = createAction(
  'CLEAR_INVENTORY_ITEM_AUDIT_LOGS'
);

export const inventoryItemAuditLogsOnChangePage = createAction(
  'INVENTORY_ITEM_AUDIT_LOGS_ON_CHANGE_PAGE'
);
